<template>
  <div class="r-consumption-query">
    <Modal v-model="show" footer-hide width="854" title="">
      <Spin size="large" fix v-if="spinShow"></Spin>

      <div>
        <div class="title">Consumption Query</div>
        <div class="common-flex common-justify-between">
          <div class="subtitle">
            Tips:in order to obtain the actual unit consumption within one hour,
            pleasecontact customer service for manual intervention.
          </div>
          <div>
            <div class="order-num">{{ consumptionQueryConfig.orderCode }}</div>
            <div class="nums">ORDER NUMBER</div>
          </div>
        </div>
      </div>
      <!-- 成功 -->
      <div
        v-if="details && details.status == 2"
        class="success common-justify-between common-flex common-align-center"
      >
        <div class="common-flex common-align-center">
          <div class="iconfont icongongyixuanzhong"></div>
          <div class="s-success">Submit success</div>
          <!-- <div class="s-consumption">Order unit consumption is 2.75</div> -->
        </div>
        <div class="time">{{ details.createDate }}</div>
      </div>
      <div
        class="s-list common-flex common-justify-between"
        v-if="details && details.status == 2"
      >
        <div class="list-item-one">
          <div class="list-item-content">{{ details.stripe }}</div>
          <div class="list-item-title">Appearance</div>
        </div>
        <div class="list-item-two" style="width:60px">
          <div class="list-item-content">{{ details.cost }}</div>
          <div class="list-item-title">Cost</div>
        </div>
        <div class="list-item-two">
          <div class="list-item-content">{{ details.strWidth }}</div>
          <div class="list-item-title">Width of cloth(m)</div>
        </div>
        <div class="list-item-three">
          <div class="list-item-content">{{ details.strStripeWidth }}</div>
          <div class="list-item-title">Strip width(cm)</div>
        </div>
        <div class="list-item-four">
          <div class="list-item-content">{{ details.strGridWidth }}</div>
          <div class="list-item-title">Grid size(cm,length*width)</div>
        </div>
        <div class="list-item-five">
          <div class="list-item-content">{{ details.clipping }}</div>
          <div class="list-item-title">Whether to cut twice</div>
        </div>
      </div>
      <!-- 失败 -->
      <div
        v-if="details && details.status == 0"
        class="
          fail
          success
          common-justify-between common-flex common-align-center
        "
        style="height:auto"
      >
        <div style="color: #c9000f" class="common-flex common-align-center">
          <div style="color: #c9000f" class="iconfont iconshibai"></div>
          <div style="color: #c9000f" class="s-success">error</div>
          <div style="color: #c9000f;width:530px" class="s-consumption">
            {{ details.error }}
          </div>
        </div>
        <div class="time">{{ details.createDate }}</div>
      </div>
      <!-- 进行中 -->
      <div
        v-if="details && details.status == 1"
        class="
          pending
          success
          common-justify-between common-flex common-align-center
        "
      >
        <div style="color: #081938" class="common-flex common-align-center">
          <div style="color: #081938" class="iconfont iconsousuozhong"></div>
          <div style="color: #081938" class="s-success">Query in progress…</div>
        </div>
        <div class="time">{{ details.createDate }}</div>
      </div>
      <div class="common-flex common-flex-wrap common-justify-between">
        <div
          class="full-width common-flex common-flex-wrap common-justify-between"
        >
          <div style="width: 170px">
            Appearance<span style="color:red">*</span>
          </div>
          <Select
            v-model="params.strStripeId"
            @on-change="changestrStripe"
            style="width: 600px"
          >
            <Option
              v-for="item in appearanceList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="half-width common-flex">
          <div style="width: 170px">
            Width of cloth(m)<span style="color:red">*</span>
          </div>
          <Input
            style="width: 200px"
            v-model="params.strWidth"
            type="number"
          ></Input>
        </div>
        <div class="half-width common-flex">
          <div style="width: 170px">
            Strip width(cm)<span style="color:red">*</span>
          </div>
          <Input
            style="width: 200px"
            v-model="params.strStripeWidth"
            type="number"
          ></Input>
        </div>
        <div class="half-width common-flex">
          <div style="width: 170px">
            Grid size(cm,length*width)<span style="color:red">*</span>
          </div>
          <Input
            style="width: 200px"
            v-model="params.strGridWidth"
          ></Input>
        </div>
        <div class="half-width common-flex">
          <div style="width: 170px">
            Whether to cut twice<span style="color:red">*</span>
          </div>
          <Select
            v-model="params.strTwoClipping"
            @on-change="changeWhetherTwice"
            style="width: 200px"
          >
            <Option
              v-for="item in whetherTwice"
              :value="item.pos"
              :key="item.pos"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
      </div>
      <div class="common-flex common-flex-end" style="margin-top: 60px">
        <div class="back common-hover" @click="show = !show">Back</div>
        <div class="submit common-hover" @click="submit">Submit</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "rConsumptionQuery",
  data() {
    return {
      spinShow: false,
      show: false,
      model1: "",
      appearanceList: [],
      whetherTwice: [],
      params: {
        strStripeId: "",
        strStripe: "", //外观
        strWidth: "", // 幅宽
        strStripeWidth: "", //条格宽度
        strGridWidth: "", //方格大小
        strTwoClippingId: "",
        strTwoClipping: "", // 是否二次裁剪，1表示是，0表示否，默认是否
        orderCode: ""
      },
      cityList: [
        {
          value: "New York",
          label: "New York"
        },
        {
          value: "London",
          label: "London"
        },
        {
          value: "Sydney",
          label: "Sydney"
        },
        {
          value: "Ottawa",
          label: "Ottawa"
        },
        {
          value: "Paris",
          label: "Paris"
        },
        {
          value: "Canberra",
          label: "Canberra"
        }
      ],
      details: ""
      //   consumptionQueryShow: false,
    };
  },
  watch: {
    consumptionQueryShow: {
      handler(newval) {
        this.show = newval;
        if (newval) {
          for (let key in this.params) {
            this.params[key] = "";
          }
          this.getOrderSearch();
          this.getOrderCostDetail();
        }
      },
      immediate: true
    },
    show(newval) {
      console.log("newval", newval);
      if (!newval) {
        this.$emit("hideShow");
      }
    }
  },
  mounted() {},
  methods: {
    ...mapActions([
      "getOrderSearchAction", //字典
      "pushOrderCostAction", //单耗
      "getOrderCostDetailAction" //单耗详情
    ]),
    getOrderCostDetail() {
      this.getOrderCostDetailAction({
        orderCode: this.consumptionQueryConfig.orderCode
      }).then(res => {
        // cosnole.log('res',res)
        if (res.data) {
          this.details = res.data;
        } else {
          this.details = "";
        }
      });
    },
    changestrStripe(e) {
      this.appearanceList.map(item => {
        if (e == item.id) {
          this.params.strStripe = item.zhName; //外观
        }
      });
      // console.log('e',e)
    },
    changeWhetherTwice(e) {
      this.whetherTwice.map(item => {
        if (e == item.pos) {
          this.params.strTwoClippingId = item.id; //外观
        }
      });
      // console.log('e',e)
    },
    getOrderSearch() {
      this.getOrderSearchAction({
        category: 14
      }).then(res => {
        this.appearanceList = res.data;
      });
      this.getOrderSearchAction({
        category: 12
      }).then(res => {
        this.whetherTwice = res.data;
        this.params.strTwoClipping = "0";
        this.params.strTwoClippingId = 10051;
      });
    },
    submit() {
      let pass = true;
      this.params.orderCode = this.consumptionQueryConfig.orderCode;
      console.log("params", this.params);
      for (let key in this.params) {
        if (this.params[key] == "") {
          this.$Message.error(key + this.$t("newOrder.cannotEmpty"));
          pass = false;
          break;
        }
      }
      // if(this.params.strWidth>=1){
      //   this.$Message.error('Width of cloth must be decimal')
      //     pass = false

      // }
      if (pass) {
        this.spinShow = true;
        this.pushOrderCostAction(this.params)
          .then(res => {
            // cosnole.log('res',res)
            if (res.code == 0) {
              this.$Message.success(res.message);
              // this.show = false
              for (let key in this.params) {
                this.params[key] = "";
              }
              this.getOrderCostDetail();
              this.$emit("uodateList");
            }
          })
          .finally(res => {
            this.spinShow = false;
          });
      }
    }
  },
  props: {
    consumptionQueryShow: Boolean,
    consumptionQueryConfig: Object
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-input {
  border: none;
  text-align: left;
}
/deep/.ivu-input:hover {
  border: none;
  outline: none;
}
/deep/.ivu-modal-body {
  padding: 30px 40px;
}
/deep/.ivu-select-selection {
  border: none;
  //  text-align: center;
}
.back,
.submit {
  width: 116px;
  height: 40px;
  // opacity: 0.3;
  font-size: 14px;
  font-family: Roboto, Roboto-Bold;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  line-height: 16px;
  background: #b5bac4;
  line-height: 40px;
}
.submit {
  background: #0a4dcc;
  margin-left: 14px;
}
.full-width,
.half-width {
  width: 774px;
  height: 40px;
  margin-top: 25px;
  border-bottom: 1px solid #e6e8eb;
}
.half-width {
  width: 372px;
}
.ivu-select-placeholder {
  border: none;
}
.s-list {
  width: 774px;
  background: #f1f7f1;
  white-space: nowrap;
  padding: 10px 20px;
  .list-item-one {
    width: 140px;
  }
  .list-item-two {
    width: 85px;
  }
  .list-item-three {
    width: 75px;
  }
  .list-item-four {
    width: 130px;
  }
  .list-item-five {
    width: 100px;
  }
  .list-item-content {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 20px;
    letter-spacing: 1px;
  }
  .list-item-title {
    opacity: 0.4;
    font-size: 10px;
    transform: scale(0.8);
    // font-family: ArialMT;
    text-align: left;
    color: #081938;
    line-height: 11px;
    letter-spacing: 1px;
    margin-left: -12px;
  }
}
.success {
  width: 774px;
  background: #e3efe3;
  height: 44px;
  padding: 14px 15px;
  margin-top: 20px;
  .icongongyixuanzhong {
    color: #0c750e;
    font-size: 16px;
    line-height: 16px;
  }
  .iconshibai {
    font-size: 16px;
    line-height: 16px;
  }
  .iconsousuozhong {
    font-size: 16px;
    line-height: 16px;
  }
  .s-success {
    margin: 0 25px 0 6px;
  }
  .s-consumption,
  .s-success {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #0c750e;
  }
  .time {
    opacity: 0.4;
    font-size: 12px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 14px;
  }
}
.fail {
  //   width: 774px;
  //   height: 44px;
  background: #fcf0f1;
  //   padding: 14px 15px;
  //   margin-top: 20px;
}
.pending {
  background: #f8f8f8;
}
.title {
  font-size: 30px;
  font-family: Times, Times-Bold;
  font-weight: 700;
  text-align: left;
  color: #000000;
  line-height: 37px;
}
.subtitle {
  width: 337px;
  height: 28px;
  opacity: 1;
  font-size: 12px;
  font-family: Times, Times-Roman;
  font-weight: Roman;
  text-align: left;
  color: #666666;
  line-height: 14px;
}
.order-num {
  font-size: 16px;
  font-family: Roboto, Roboto-Medium;
  font-weight: 500;
  text-align: center;
  color: #000000;
  line-height: 19px;
  text-align: right;
}
.nums {
  opacity: 0.4;
  font-size: 12px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-align: center;
  color: #000000;
  line-height: 14px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/r-consumption-query.vue